import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'left' | 'right' | 'none';
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0,
  direction = 'up'
}: AnimatedSectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const getInitialOffset = () => {
    switch (direction) {
      case 'up':
        return {
          y: 30,
          x: 0
        };
      case 'left':
        return {
          x: 30,
          y: 0
        };
      case 'right':
        return {
          x: -30,
          y: 0
        };
      case 'none':
        return {
          x: 0,
          y: 0
        };
      default:
        return {
          y: 30,
          x: 0
        };
    }
  };
  const initialOffset = getInitialOffset();
  return <motion.div ref={ref} initial={{
    opacity: 0,
    ...initialOffset
  }} animate={isInView ? {
    opacity: 1,
    x: 0,
    y: 0
  } : {
    opacity: 0,
    ...initialOffset
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-112">
      {children}
    </motion.div>;
}